import { createContext, useContext } from 'react'
import type { AgentOptions, AgentToolInfo } from '@/services/api/agent'

export const DEFAULT_AGENT_OPTIONS: AgentOptions = { disabled_tools: [], deep_mode: false }

interface AgentOptionsContextValue {
  /** Effective per-thread options (server value overlaid with in-flight edits). */
  options: AgentOptions
  /** Toggleable tools for the current scope (case vs lake). */
  availableTools: AgentToolInfo[]
  /** Persist new options on the thread. No-op outside a chat host. */
  updateOptions: (next: AgentOptions) => void
}

export const AgentOptionsContext = createContext<AgentOptionsContextValue>({
  options: DEFAULT_AGENT_OPTIONS,
  availableTools: [],
  updateOptions: () => {},
})

export function useAgentOptions(): AgentOptionsContextValue {
  return useContext(AgentOptionsContext)
}
